import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-bottom: 2px solid var(--alias-color-line-alternative);
`;

export const GWSMemberSyncContainer = styled.div`
  display: flex;
  padding: 20px 28px 12px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const LeftContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const SyncBtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const GWSMemberSyncInfoContainer = styled.div`
  display: flex;
  padding: 12px 28px 12px 40px;
  align-self: stretch;
  box-sizing: border-box;
  gap: 8px;
  flex-direction: column;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MemberSyncInfoGrayContainer = styled.div`
  display: flex;
  height: 80px;
  max-height: 80px;
  padding: 8px 12px;
  align-items: flex-start;
  gap: 4px;
  overflow-y: auto;
  box-sizing: border-box;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-strong);
  background: var(--alias-color-background-normal-alternative);
`;

export const MemberInfoSyncContainer = styled.div`
  display: flex;
  padding: 12px 28px 20px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const MemberInfoSyncChannel = styled.div`
  display: flex;
  padding: 20px 28px 20px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const AlarmChannelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const AlarmChannelLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
